import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "site-header",
  id: "header"
}
const _hoisted_2 = { class: "navbar navbar-expand-lg transparent-bg static-nav" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/fe/asset/img/logo.png",
    alt: "logo",
    class: "logo-default"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/fe/asset/img/logo.png",
    alt: "logo",
    style: {"max-width":"70px"},
    class: "logo-scrolled"
  })
], -1)
const _hoisted_5 = { class: "collapse navbar-collapse" }
const _hoisted_6 = { class: "navbar-nav ml-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:void(0)",
  class: "d-inline-block sidemenu_btn",
  id: "sidemenu_toggle"
}, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_SideMenu = _resolveComponent("SideMenu")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createVNode(_component_Menu)
          ])
        ])
      ]),
      _hoisted_7
    ]),
    _createVNode(_component_SideMenu)
  ]))
}